import axios from "axios";
import { checkToken } from "../../utils/tokenHelper";
const apiUrl = process.env.REACT_APP_API_URL ?? 'http://127.0.0.1:8000/api/';

const API = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const getBlogListAPI = async (token) => {
    try {
        const response = await API.get('admin/blogs', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};

// Create a new category
export const createBlogAPI = async (formData, token) => {    
    try {
        const response = await API.post('admin/blogs/store', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data', // Required for file uploads
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error; // Re-throw error for further handling
    }
};

// Create a new category
export const getBlogAPI = async (id, token) => {    
    try {
        const response = await API.get(`admin/blogs/show/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const updateBlogAPI = async (formData, id, token) => {    
    try {
        const response = await API.post(`admin/blogs/update/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const deleteBlogAPI = async (id, token) => {    
    try {
        const response = await API.get(`admin/blogs/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};